<div class="container" [class.collapsed]="!expanded()">
  <div class="head" [class.collapsed]="!expanded()">
    @if (expanded()) {
      <div class="logo" (click)="!expanded() && toggleSidebar()">
        <app-logo [variant]="'icon'"></app-logo>
      </div>
    }

    <button
      type="button"
      class="collapse-btn"
      (click)="toggleSidebar()"
      aria-label="Collapse sidebar"
    >
      @if (expanded()) {
        <mat-icon svgIcon="nav_collapse"></mat-icon>
      } @else {
        <mat-icon svgIcon="nav_expand"></mat-icon>
      }
    </button>
  </div>

  @for (link of links(); track link.url) {
    @if (link.children?.length) {
      <!-- Group links -->
      <div class="nav-group" [class.expanded]="isGroupExpanded(link)">
        <div class="nav-group-layout">
          @if (link.icon) {
            <div class="nav-group-icon-column">
              @if (expanded()) {
                <!-- Navbar is big -->
                <span class="nav-icon">
                  <mat-icon>{{ link.icon }}</mat-icon>
                </span>

                @if (isGroupExpanded(link)) {
                  <span class="nav-group-line" aria-hidden="true"></span>
                }
              } @else {
                <!-- Navbar is small -->
                <button
                  type="button"
                  class="nav-icon nav-icon-btn"
                  (click)="toggleGroup(link)"
                  [attr.aria-label]="link.title"
                >
                  <mat-icon>{{ link.icon }}</mat-icon>
                </button>
              }
            </div>

            @if (expanded()) {
              <div class="nav-group-content">
                <button type="button" class="nav-group-header" (click)="toggleGroup(link)">
                  <span class="nav-group-title">{{ link.title }}</span>
                  <mat-icon class="expand-icon">
                    {{ isGroupExpanded(link) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>

                @if (isGroupExpanded(link)) {
                  <!-- If expanded, render first level children -->
                  <div class="nav-group-children">
                    @for (child of link.children; track child.url) {
                      <a
                        class="nav-group-link"
                        [routerLink]="link.url + '/' + child.url"
                        routerLinkActive="nav-group-link-active"
                      >
                        {{ child.title }}
                      </a>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    } @else {
      <!-- Page links (leaf nodes) -->
      <div class="nav-item">
        <a class="nav-link" [routerLink]="link.url">
          @if (link.svgIcon) {
            <span class="nav-icon">
              <mat-icon [svgIcon]="link.svgIcon"></mat-icon>
            </span>
          } @else if (link.icon) {
            <span class="nav-icon">
              <mat-icon>{{ link.icon }}</mat-icon>
            </span>
          }

          @if (expanded()) {
            <span class="nav-title">{{ link.title }}</span>
          }
        </a>
      </div>
    }
  }
</div>
